/* eslint-disable max-depth */
/* eslint-disable array-callback-return */
import { ActionRuleParams } from '../../types';
import { hasKitchenReferenceRule } from '../../helpers';

export const shippingPromo = (params: ActionRuleParams): void => {
	// console.log('rule:func:-> shippingPromo', params);
	const { refMap } = params;
	const updatePromo = hasKitchenReferenceRule({ refMap, rule: 'ShippingPromo' });

	if (updatePromo) {
		const shippingPromos = refMap.kitchen.promotionalSkus.children.filter((sku) => sku.sku === 'SHIPPING');

		if (shippingPromos.length === 0) {
			refMap.kitchen.promotionalSkus.newSku('SHIPPING');
		}
	}
};
